module.exports = __webpack_public_path__ + "img/icon_tc_policy.9be1c102.png";